import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`We reflect the IBM brand in the built environment through lively and provocative applications. Our brand expression moments range from the overt, such as signage and environmental graphics, to the subtle, such as material choices and pattern. Every element application contributes to a cohesive and differentiated experience in our environments.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Foundation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Environmental elements</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Art elements</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Technology installations</AnchorLink>
    </AnchorLinks>
    <h2>{`Foundation`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/"
      }}>{`IBM Design Language`}</a>{` forms the foundation for every user experience across every design discipline, including digital, physical and visual applications. Essential elements include logos, grid, typography, iconography, color and many others. Use the resource links shown here to learn more about these core components and download supporting assets.`}</p>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Logos" href="https://www.ibm.com/design/language/elements/logos/8-bar" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAAA70lEQVQ4y2NgGAWDBjAyMhKrlImJSUREREhIiJ+fX1xcHEiys7MDRZiZmSEMFhYWnDZwcnLW1dXl5eXFxsY2NDSkpaV5eXl1dXXp6Oj4+vq2trYKCwtjdw7QWiAJVG1kZCQhIVFUVJSbm6umphYfH19QUFBaWurj44PTIxDNDg4OQHuAmoGWR0ZGamhoODo6RkVFBQcH29jYYNcMEeLg4MjJyQFaFRgYCLQWqNnNzS0pKUlJScnAwCA7OxsYHDgtBwaMoqKinJyclJSUqqqqqKgoLy+vvLw8UDXQXKAUGxsbzSKWCQkwwgDJcT4KsAMAWewsgxVtc3gAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM Logo",
              "title": "IBM Logo",
              "src": "/workplace-xg/static/b27134c35dd583ceeb9ef7ef837c7614/1b824/foundation-logos.png",
              "srcSet": ["/workplace-xg/static/b27134c35dd583ceeb9ef7ef837c7614/7fc1e/foundation-logos.png 288w", "/workplace-xg/static/b27134c35dd583ceeb9ef7ef837c7614/a5df1/foundation-logos.png 576w", "/workplace-xg/static/b27134c35dd583ceeb9ef7ef837c7614/1b824/foundation-logos.png 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="2x Grid" href="https://www.ibm.com/design/language/elements/2x-grid" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAAA3UlEQVQ4y+2TzQ6CMBCEeRtoRQsBtAXe/7n80omlYOXkxcQ5mOnuzv5KdSnBGPNutNbmdp7VX/wNMY6cX1+wEZvYZkjWuq5NBOQeMU3TOI4Q5xx2dVEdCoKmabz3IYRHxDzPbdtqlr7vSQHBsmubrhAsyzIMA5qu64hQliTGiFeTb2IYDkL5VZPkogWykE4BPPEWKmsriNd1xY0YTYggl4i6YGZtZ9c2D5T4NDMabQVCfbiqfTwV+1DELUL7cxGSnd05+SieXy5t6Ci2JUh8bj/e+Yc+jOJs+vee2+FP0FbOQfD6jekAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "2x Grid",
              "title": "2x Grid",
              "src": "/workplace-xg/static/9049c97b5cdf485c6ca3267b996c0ff7/1b824/foundation-2xgrid.png",
              "srcSet": ["/workplace-xg/static/9049c97b5cdf485c6ca3267b996c0ff7/7fc1e/foundation-2xgrid.png 288w", "/workplace-xg/static/9049c97b5cdf485c6ca3267b996c0ff7/a5df1/foundation-2xgrid.png 576w", "/workplace-xg/static/9049c97b5cdf485c6ca3267b996c0ff7/1b824/foundation-2xgrid.png 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Typeface" href="https://www.ibm.com/design/language/elements/typeface" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAACdElEQVQ4y6VTS0uqURRV0x6+ysDMZ5qiRpJSg0QRFXxgpU7KFxqkWGLNEtFBSETOxIGgIIgj5w7EoRMRp/6ku3B/fHLvpODuwWGds791ztpr74/D+f/g8XiHh4dYaQu8tbVF2OfzBYNBwlwuF6tard7d3d2QDw4OLi8vt7e3afvw8LC/vw+g0Wi+v79ns9nz8zOlLBbL19eXUCjk/HMfS769vRWLxYQNBsN8Pr+5uQFWKpUej+fu7o4oTOzt7YFM+rFarVYShsNQKDQajT4/P7F9XMfb2xtbFIfP5+v1+vPz852dHTpxOBxSqRRAq9X2er1+v39xcUEaIdtms7F6GcNw2V9ifhnidYAvk8m461AoFDAMQoBxKewUCASkEVqwbp6BkqenJ5QXj8exPTk56Xa7q9WqVCqRcqRgO7Db7a5UKoFAgHGHHAqHw8Vikb0S3k6nUzwOI2EHTkwmE9ZYLNbpdFwuFznC1A2HqtWqSCQCdjqdYNJTEEwjgYbhmUKhUC6Xm82m2WxmZAP5/X673Z7P57EFc7lcfnx8oFoMA8hoL2YOqdfX11QqNRwOccKQ4RMU4mKVSgXl+E6n06FyyiJFTATuMhqNWBnZP8YP/cOb6XT6/f0dhWGLeQCORqNEg/hkMomBBc5kMhj1Wq0mkUg2swl7crkc6sE2kUjAFXSIsu12ezKZHB8fA2O2jo6OstksqtuoQu7l5YUmAYONZjQaDVx6dna2WCzQ9larxU4uus30mcggeL1eSmPIQa7X6yDj0/F4PBgM7u/vqQT8GPS3bl6Wy+Wnp6esvZFIBK5S9vr6+urqilIgb5r0+2A9p+En/Adf+IfQ+dUVPgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Typeface",
              "title": "Typeface",
              "src": "/workplace-xg/static/43b2addf6fb98aaefdcff2ff03fbd5b5/1b824/foundation-type.png",
              "srcSet": ["/workplace-xg/static/43b2addf6fb98aaefdcff2ff03fbd5b5/7fc1e/foundation-type.png 288w", "/workplace-xg/static/43b2addf6fb98aaefdcff2ff03fbd5b5/a5df1/foundation-type.png 576w", "/workplace-xg/static/43b2addf6fb98aaefdcff2ff03fbd5b5/1b824/foundation-type.png 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Pictograms" href="https://www.ibm.com/design/language/elements/pictograms/design" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAABWUlEQVQ4y+WSWU/CQBDHd44l3PdRoFBOudS2AjaES0RiKsYEiW/ou9//CwjFBB8o8s5kJ5nM5jf/2Z0R4tINALwB8PrBFwR/SCAJ2CUPx43beSAql99yvJaWLQfPqF05N/i/6M6DcZ5+YqGJ6QLVDdaHfD/j7pD0PtUaZHYhntg3eAz2hkm3MVl0uohwfyHtjRzb1BuxNfE8vaBWdofDadJ6kChAQoWYwjdj7s3l/ANCUblY8Z2FWfUo7Jj0YW2E+Q6qbSzp3Jmw/oBKCQJhLDWo2kJVc4eFQM1iY4W59lafyiY1LYgkMV/1LL/k9BUzeXeYPNSyub/BgkG1gUCGWIbao624nK7JGGH2hDJJaq/4+p2qY6wMMH9LlR733zClYqaIubKQnlMTQ8XAyozqj6ia+yFjUYdw6tRT/y7ZrkTOFOz7TUSU7f85hemsbREoD4u1Dc7ALsV+ALYiIRz25HhhAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Pictograms",
              "title": "Pictograms",
              "src": "/workplace-xg/static/08cbd90c4f3e69ffade471338fe0b183/1b824/foundation-pictos.png",
              "srcSet": ["/workplace-xg/static/08cbd90c4f3e69ffade471338fe0b183/7fc1e/foundation-pictos.png 288w", "/workplace-xg/static/08cbd90c4f3e69ffade471338fe0b183/a5df1/foundation-pictos.png 576w", "/workplace-xg/static/08cbd90c4f3e69ffade471338fe0b183/1b824/foundation-pictos.png 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Color" href="https://www.ibm.com/design/language/elements/color" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAADWElEQVQ4y8XN609TZxzA8V/TPQwBm+zVQPbCguJlMdBTWBjMVlqgp4WWAruELNBzWjqH0AsSkRYwRIltbeslCvRmhSIsQaeL/4DZFjcEOtR5A3XZqyW6bGxdFxd62rOenWd/gS9MPm+/+cJgXg3vSF6NI/+DaKEuVqSfKdJPF+nntrXFy0z3dpnv7jLfKeu+/27Pry2ujQ99v7d7efD64qNbqnmDW6qdee9fertptlAbK9TOFGrni3SrOw33y+gfy+h7O6mHe82/6cb/bPf80ebmwUBBHe9wQd3gVmVo2yfR4o6LxR2R4o6Zdz5d3G2N77Gv7LEv77at7hv4pfXsi48vPP/oPA9at5/j6befbRdfsFXc7Jd82y/5xi75eoD4zrt/44zs79OypH9/8pwi+cXnyQVLcqEPA11JgKctmdKXRnqJRYs0bpGu9EmXbZV3TspT7gNslkvOeuvZmUPpOXv6sg0DnXiSpxVP6EtCvZJbFmLJQtzuIxZt0rhL9tIjT3vkjFvG+JRMrGdz3rY5Z8WgRTzJ04knWktCfZJbVmLJSty2EIt2adwte3lKnj4lZzwyxq9kZv+L560YqEqDvMbSgHpHhKr83li1YqxapquWut9bHVL841SmnUrGoWBGVcyUZTN8eDPUj0F++ZX/LeRLrokaH4jINRH5WKR6JNI8KehMFRjYrPwu9i0TqxxnNB5G7cZAWPElVn5VSHwlJB8JNU+EmnWhek3Y/AxoBkwsx8iig2y1m5H7GZkPA1RxFSu/gojriHyINOtIs4bUj1HzUwGVEhhZgTEDdObNzzI1rlSdL3XAi2Xj61j5NUTcQOQ6Uv+E1M8Q+RQ1/QyGNNAsh2JzzGytK6PwZeq8GCBiFpPEUOU80iyj5lXU/ANqiiPdXTBtgPkvMCegO4F6ElWeRO3pRI2fU+tPACj1mKIFGtqgswcMvZyuQ0BbwHEchsc5zhOCY66cQDQnMp0Tnn4jdGnrxRhAQyNW3wAqEgydQBs4VBeYaBg+AqNHOSODMOaE4HmITHLCE7nRQDZWY/UkqJrAQAFt5FA0mLpheAhGnZwRh2BsVBDMlkFOOJAbDWdjEqtXgUoDhuyW5lAUmEwwnN06OCNDgrERQXACIgFOeCo3Gnql+F9qffAewNGC2wAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color",
              "title": "Color",
              "src": "/workplace-xg/static/8189eca40c0f389c25deab63d63f23c9/1b824/foundation-color-palette.png",
              "srcSet": ["/workplace-xg/static/8189eca40c0f389c25deab63d63f23c9/7fc1e/foundation-color-palette.png 288w", "/workplace-xg/static/8189eca40c0f389c25deab63d63f23c9/a5df1/foundation-color-palette.png 576w", "/workplace-xg/static/8189eca40c0f389c25deab63d63f23c9/1b824/foundation-color-palette.png 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Illustration" href="https://www.ibm.com/design/language/illustration/overview/" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "608px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBf/EABcBAAMBAAAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAeYpusyAaE4iD//EAB0QAAICAQUAAAAAAAAAAAAAAAECABIRAxMiIzL/2gAIAQEAAQUCXLCxhNYx3G7GNmEXnND0ww3/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAZEQABBQAAAAAAAAAAAAAAAAAAARARQXH/2gAIAQIBAT8BwkSm/8QAHhAAAgICAgMAAAAAAAAAAAAAAAERIQIxElFhcYH/2gAIAQEABj8CeN1pEcVOtESq8Goa72eqIycGTyuEfBo//8QAHhABAAICAgMBAAAAAAAAAAAAAQARMUEhUWFxsdH/2gAIAQEAAT8hKx2Wbhmhu/EReI5lKg95yhYcOR+RfZRqrmcq4FYLZb6MqjXc/9oADAMBAAIAAwAAABA0CLz/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EGYOf//EABoRAAICAwAAAAAAAAAAAAAAAAABETFRkfD/2gAIAQIBAT8QScpSIZ7Zdh2f/8QAHBABAQACAwEBAAAAAAAAAAAAAREAMSFRkUFx/9oACAEBAAE/EHjJhB4eXBIYbeQdYSs9G1PMgfFOBOjIqyaBP19cQcW6K9wxYaxTKcIq0MJQopds/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Illustration",
              "title": "Illustration",
              "src": "/workplace-xg/static/29e7b25eb36cd501b71241f205452e0a/f9b01/foundation-illustration.jpg",
              "srcSet": ["/workplace-xg/static/29e7b25eb36cd501b71241f205452e0a/69549/foundation-illustration.jpg 288w", "/workplace-xg/static/29e7b25eb36cd501b71241f205452e0a/473e3/foundation-illustration.jpg 576w", "/workplace-xg/static/29e7b25eb36cd501b71241f205452e0a/f9b01/foundation-illustration.jpg 608w"],
              "sizes": "(max-width: 608px) 100vw, 608px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
    </Row>
    <h2>{`Environmental elements`}</h2>
    <p>{`IBM’s rich legacy of design affords many opportunities to enhance our sense of identity and culture as we build our environments. Brand expression in the workplace must have a longer lifespan than typical marketing or event experiences. Campaigns evolve over time, but our facilities need to stay relevant for years. Multiple teams or business units often rotate through the same workspace. With this dynamic use in mind, it’s critical we employ timeless elements of the IBM master brand that will endure over time, and avoid references to marketing or advertising. The examples shown here represent a spectrum of creative executiions that may be customized based on project needs.`}</p>
    <p>{`Download the `}<a parentName="p" {...{
        "href": "https://ibm.ent.box.com/s/i9vvhd4kg7hmj593oms8zsun9559j3yw"
      }}>{`IBM Workplace Brand Expression document`}</a>{` to learn more about the design and implementation of environmental elements.`}</p>
    <ImageCollection mdxType="ImageCollection">
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsSAAALEgHS3X78AAACRklEQVQoz2P4DwZ//vz9/efP79+o6A8q4w8I/f377z8MMPwnHfz79w9F8/LV++paFrZ2L2rpmNPSMRdMzmnpWgxidy5o6V4K5LZ2L6xtXrBr31mg+r9g/Qz/waa4hvQxsEQxC8YzcHoz8EYwcPkxcPkwcPkzcAeCRHhCGDjcmQVjGdhi4nNnvX71FGI/A8QFkdXrue26pLwmidpWS7hPELNvELEsFLWvE3NuF7YsFrIoFLGpkPCYKOI+JSB7ckdbE8jyv3+hzq7tX+UU0+KR0Gzhk+UQXmHtn2fpl2sbVGgbVGQXXOwYUWHln+caU+eZ0lPeMnPe3NlQmyGaV63d1NLR3941ob6prbGls6G5va6xrbm9t6Gls6Wjr6N3SkNzZ2tHf1vXxI1btj98+BASZAxkBDXQwSihfejkg2XrL2/efWP/sbu7Dt7ed+QuEG3ceX3P4Tvb999as/Xq/mP3tu65uXT9pQtXn8NjC6p58trnSR33CqY8alvyvHTGk6aFz1oXP2tY8KRu3tP2JU9rZj/uXvG8cMqjlK6Hczfee/TwDrKf/605+699x//e3f/nHvnfs+v/rMP/l5/6P/vw/yn7/i85+X/Zqf8Ljv3v2fl34qH/E1ZeaKyvRg7tf1ef/D1y+//J+/8vPP5/+sH/c4/+n3sIQmfB6AxY5OS9v2ce/9957Ma0qZNRQvvT119vP/388OXn528/P38FoS/ffn78+vPT158fv/x8/xkkApR9//X3i9fvbt++hZa2/xGN/lOUMeAAAO0kx+OwKCiiAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "2 IBM logo gradient wall environmental element renders",
            "title": "2 IBM logo gradient wall environmental element renders",
            "src": "/workplace-xg/static/e725fb3df3f7c018167a7f18c3196c0e/3cbba/environmental-elements.png",
            "srcSet": ["/workplace-xg/static/e725fb3df3f7c018167a7f18c3196c0e/7fc1e/environmental-elements.png 288w", "/workplace-xg/static/e725fb3df3f7c018167a7f18c3196c0e/a5df1/environmental-elements.png 576w", "/workplace-xg/static/e725fb3df3f7c018167a7f18c3196c0e/3cbba/environmental-elements.png 1152w", "/workplace-xg/static/e725fb3df3f7c018167a7f18c3196c0e/92c65/environmental-elements.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFGaSxBRI//xAAaEAEAAgMBAAAAAAAAAAAAAAACAAEDERIh/9oACAEBAAEFAsg9GLalirhGnwZ//8QAGBEAAgMAAAAAAAAAAAAAAAAAABEBAlH/2gAIAQMBAT8BUitp/8QAGREAAgMBAAAAAAAAAAAAAAAAABEBAhJR/9oACAECAQE/AdQh14f/xAAZEAACAwEAAAAAAAAAAAAAAAABEAAhMTL/2gAIAQEABj8C6VkPJ//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExQZH/2gAIAQEAAT8hsVp2EoZnZoFhqcbGLTmnZb5+T//aAAwDAQACAAMAAAAQC/8A/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEh8f/aAAgBAwEBPxC5OB//xAAXEQEBAQEAAAAAAAAAAAAAAAABADHx/9oACAECAQE/EMAR0X//xAAeEAEAAgEEAwAAAAAAAAAAAAABABEhMVFhcYHB8P/aAAgBAQABPxB6gYUYCEE9r2RDdQG23vGsdVLNu0YMGTdX3PiAC1orIZ//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM logo as wall graphic",
            "title": "IBM logo as wall graphic",
            "src": "/workplace-xg/static/9bddd6d32e4043242f1f67e806c39f4a/473e3/ibm-logo-as-wall-graphic.jpg",
            "srcSet": ["/workplace-xg/static/9bddd6d32e4043242f1f67e806c39f4a/69549/ibm-logo-as-wall-graphic.jpg 288w", "/workplace-xg/static/9bddd6d32e4043242f1f67e806c39f4a/473e3/ibm-logo-as-wall-graphic.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAADjUlEQVQ4yx2U3VMUZBTG35v+BLupZprpostuavImq6lmHC9yGpssu0ztwqSmLBtqyqQCxEA0hUgBPyCQQJHv74+F5RsXhAV2+V5gd4FWF6VAlF/ncWfnnZ19z3nOOc/znNeV3+bOAvsu8GURV7y8kUp2CzXDXPWSUsWeM7yYSPsEvjl2pfB6KsdLaB0np5WzDbihEKv3Cd/jTD07Etj5M9mt/FJJXgena7kxQCCi28ZRvivl8Tanasjz4A1SNYQLxSjp41Q1G4947igvJRJbZzjEyhrXe/nxJheayWzAOymUoXmW15hZoX6E2RVcw6gaXrrLgw1+reS3WvxLdE3RNclEmL+6SanmWDGvJFE/SlYzpf1MLdM9JVD3aS7fFPNTOfkdwg79w+HLvJXGO2kasnVMoaMLOq354l7K+hldZN95lXQGVj2skZIrCUaVf62Lm4O8lyEIm+hSO23jatXye6YVk1bNzhNsPcaBMKxI/F9hR+Jc6VTDuR71shCjM8j0CoGwAop6FGPMvX2aqShucFbVLrYLOxwXH3+0KrN/lodbTEZYXWPzkSDGw5QN0DetszPAxhYuqYJvS2j2M70swf2LGP+5HbSMSRKjJ7mKYATfPH0zyinoesJ5nJO3cFbEnGD/Ws2aOyT+TZOfq11MRnn+a8428mE2f7YJundaLrq/QUad/GNMORssvY5rXmnbPCZte6Yo7Fbo54U0jBB7INlMG6s8MMv3Zbx8UsHb27iOILXDsK2Cxu2rSbLO7nTZwz5m1WNF4t80M80N/f1M9qZjw9pQcti5RrFqjrVWd3zGV0U8fUR3xpAJc76JwTndGtVyToTD+RzIEUHOE5D7rJptiLVqpw12vU9+PFogkd0HatVEMS9YCyZb/4wEbxnHXWwTsXUjfFH4ZHvmxc1ijNtz4sJ8+mYqNwYZW1RZEyUQVbG2CQE548A0tGVyH/FuJnOr+n6cLaBGP4fyZInXUpRgKv7exC2ffltmQiHOF+KTLNxunklgT4aq/bfJ/izKfRzM4dkjrD/kh1I1X9BNhY9LHrnVhDiUjzMCLndqPOs8uib1onE8E4wvyRsdAXGeXMFTB7UPNq05ZHOLu+sq40YWtEn2bqxvyKGmhz0jxp8tjK2+YZlJXjguXpbuKdlATfMT5ew9h6vy6Q3JapHvTZiMepUyS9lzs402pNLH/mxtjlnQHGVbabaxAJPmf97/0cxDcVnWAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "typography pattern",
            "title": "typography pattern",
            "src": "/workplace-xg/static/a37080cb4aa898fc60e59b58cd6a6d79/a5df1/typography-pattern.png",
            "srcSet": ["/workplace-xg/static/a37080cb4aa898fc60e59b58cd6a6d79/7fc1e/typography-pattern.png 288w", "/workplace-xg/static/a37080cb4aa898fc60e59b58cd6a6d79/a5df1/typography-pattern.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMCBP/EABQBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAexPDNEQX//EABsQAAIBBQAAAAAAAAAAAAAAAAECIQADERIx/9oACAEBAAEFAnbA6jqCRcjYlZr/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwEn/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/AbWv/8QAHBAAAQMFAAAAAAAAAAAAAAAAAQAQMQISIUFh/9oACAEBAAY/AqRsloRvxxpX/8QAGhABAQEAAwEAAAAAAAAAAAAAAREAITFRof/aAAgBAQABPyFDC/Ddwk5PEwZ8TjXk7MGDBAblrtv/2gAMAwEAAgADAAAAEHDv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EAtl/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERcf/aAAgBAgEBPxBC0g//xAAcEAEBAAMAAwEAAAAAAAAAAAABEQAhMUFhcZH/2gAIAQEAAT8Q1piCUaK/iZwNaux3EVCFaTWaMpKhp78XDCGltJeY3j+Of//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "typography pattern on wall",
            "title": "typography pattern on wall",
            "src": "/workplace-xg/static/425048ec67602ad327ed59794e246121/2e753/typography-pattern-on-wall.jpg",
            "srcSet": ["/workplace-xg/static/425048ec67602ad327ed59794e246121/69549/typography-pattern-on-wall.jpg 288w", "/workplace-xg/static/425048ec67602ad327ed59794e246121/473e3/typography-pattern-on-wall.jpg 576w", "/workplace-xg/static/425048ec67602ad327ed59794e246121/2e753/typography-pattern-on-wall.jpg 1152w", "/workplace-xg/static/425048ec67602ad327ed59794e246121/a052a/typography-pattern-on-wall.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABqxKF/8QAFhABAQEAAAAAAAAAAAAAAAAAERAA/9oACAEBAAEFAnNJ/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGBAAAwEBAAAAAAAAAAAAAAAAAAERIVH/2gAIAQEAAT8hhECdRERwWH//2gAMAwEAAgADAAAAEBwv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGBABAAMBAAAAAAAAAAAAAAAAAQARITH/2gAIAQEAAT8QUI3jXIgawATjFHSdMbACgon/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Think® wall signage",
            "title": "Think® wall signage",
            "src": "/workplace-xg/static/8555858a112b21d58c2f00fc673f24e8/2e753/think-wall-signage.jpg",
            "srcSet": ["/workplace-xg/static/8555858a112b21d58c2f00fc673f24e8/69549/think-wall-signage.jpg 288w", "/workplace-xg/static/8555858a112b21d58c2f00fc673f24e8/473e3/think-wall-signage.jpg 576w", "/workplace-xg/static/8555858a112b21d58c2f00fc673f24e8/2e753/think-wall-signage.jpg 1152w", "/workplace-xg/static/8555858a112b21d58c2f00fc673f24e8/a052a/think-wall-signage.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAIEAQMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAeZi5LJSoN7PSkQxX//EABoQAAIDAQEAAAAAAAAAAAAAAAABAhEiAxL/2gAIAQEAAQUC1ejQ4JHKKcZcVdI8lnp3Nln/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAfEAACAQMFAQAAAAAAAAAAAAAAAQIhMTIQERJBUUL/2gAIAQEABj8CsWMSKUX5cfNS8PtHZV7UTMmiQ9P/xAAfEAEAAQMEAwAAAAAAAAAAAAABACExQRFRYXEQgdH/2gAIAQEAAT8h6JM67TTl9RtWI0bpouna4l/aFgjUrbTiBdRFiZ8RkMkYOu0XT5P/2gAMAwEAAgADAAAAEDvkwf/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQACAgIDAAMAAAAAAAAAAAEAESExQVFhcZGBscH/2gAIAQEAAT8Qc4qx40cRoBB0o2wS6p4bSqo/0bX9gXXRvE6PdRlm6GSYK/kXfbRGkaX3zKwdeeQz+bD7HPAuhr9w8NowdSgaxcw8xIlFrpP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "historical photo of people below Think® sign",
            "title": "historical photo of people below Think® sign",
            "src": "/workplace-xg/static/068948625fb7a1b037422ec892924aed/473e3/historical-photo-of-people-below-think-sign.jpg",
            "srcSet": ["/workplace-xg/static/068948625fb7a1b037422ec892924aed/69549/historical-photo-of-people-below-think-sign.jpg 288w", "/workplace-xg/static/068948625fb7a1b037422ec892924aed/473e3/historical-photo-of-people-below-think-sign.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAD/9oADAMBAAIQAxAAAAHrhGmmRQAf/8QAFRABAQAAAAAAAAAAAAAAAAAAIBH/2gAIAQEAAQUCEP8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERURAx/9oACAEBAAE/IaJ+mEooILmH/9oADAMBAAIAAwAAABBo53//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAcEAEAAgIDAQAAAAAAAAAAAAABADERQSFRcYH/2gAIAQEAAT8QMMLBbRcniIOt2XAqcncMAxWjqX+zuNeJ/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood Think® wall signage",
            "title": "wood Think® wall signage",
            "src": "/workplace-xg/static/61a56154613f9a9356e02359451a648d/473e3/wood-think-wall-signage.jpg",
            "srcSet": ["/workplace-xg/static/61a56154613f9a9356e02359451a648d/69549/wood-think-wall-signage.jpg 288w", "/workplace-xg/static/61a56154613f9a9356e02359451a648d/473e3/wood-think-wall-signage.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHvsYN1RcAH/8QAGRABAAIDAAAAAAAAAAAAAAAAAQIQABES/9oACAEBAAEFArlBXhyJov8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGRAAAQUAAAAAAAAAAAAAAAAAABAgITEy/9oACAEBAAY/Als0Sz//xAAaEAEAAgMBAAAAAAAAAAAAAAABABEQICFR/9oACAEBAAE/Ic3MZGt67EEVvun/2gAMAwEAAgADAAAAEOPAAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABsQAQACAgMAAAAAAAAAAAAAAAERUQAxECAh/9oACAEBAAE/EOY1mAgdI4oPJKlzeQdbdun/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "dimensional outline Think® wall signage",
            "title": "dimensional outline Think® wall signage",
            "src": "/workplace-xg/static/e3e25657840bea1b0555e33f8217ec66/473e3/dimensional-outline-think-wall-signage.jpg",
            "srcSet": ["/workplace-xg/static/e3e25657840bea1b0555e33f8217ec66/69549/dimensional-outline-think-wall-signage.jpg 288w", "/workplace-xg/static/e3e25657840bea1b0555e33f8217ec66/473e3/dimensional-outline-think-wall-signage.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "578px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVQ4y+VTyU7DMBCdv0NxCilQ2gsSf4tUkbSN0wVUFgkQXOFAkarK5tmTRrZxeyFISBwmsz+/sSdEneqdUrmC/mhF8NlQZ6pbEwCuIXAq1YoEgPrH8ouAUuFxOGh0Y4d+rMaxG8BUKq8hLHT9MOba3sjbpJggWTqFpd8Y1jQ5CyhrhqWibK4pGWk6Xmo6xAqIMQRN3QUXWxDopEDsRlO24JgLahma4NFU0fkbgCQD9h64KR2xLQoGOLlF7Qw1yJ3ewa74YG9key9jRYMXTQeXKARAhqb+E9gMoZ+Rx6Fnjwxg8gbw4hMEvgGake14inr3hmk94oSbDMPBKx9g/YLz1r8G42UMsL5DkTNAcsUjJjlrke/xc2YffeXt3oXLmu6IezWxPXT3zNu5HfFwL6MM//C//F8AvwB5fU57pXfcJQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Think® logo flat monochrome wall signage",
            "title": "Think® logo flat monochrome wall signage",
            "src": "/workplace-xg/static/8ebbc3454b859e51dac46adf95783b9e/778f8/think-logo-flat-monochrome-wall-signage.png",
            "srcSet": ["/workplace-xg/static/8ebbc3454b859e51dac46adf95783b9e/7fc1e/think-logo-flat-monochrome-wall-signage.png 288w", "/workplace-xg/static/8ebbc3454b859e51dac46adf95783b9e/a5df1/think-logo-flat-monochrome-wall-signage.png 576w", "/workplace-xg/static/8ebbc3454b859e51dac46adf95783b9e/778f8/think-logo-flat-monochrome-wall-signage.png 578w"],
            "sizes": "(max-width: 578px) 100vw, 578px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwACBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHuUdDR1f/EABkQAQADAQEAAAAAAAAAAAAAAAEAAhEDBP/aAAgBAQABBQIgkpYuTJ5zOf8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAgMBAAAAAAAAAAAAAAAAARAAESFR/9oACAEBAAY/AlYedM//xAAZEAEBAQADAAAAAAAAAAAAAAABABEhUfD/2gAIAQEAAT8hxtquoikEFeY8fBv/2gAMAwEAAgADAAAAEKgP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Qh//EABoQAQEBAQEBAQAAAAAAAAAAAAERACExUUH/2gAIAQEAAT8QYXB5hgZ7OmQxRXtiMc4t7T7jc0v3fiUs+Vrf/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum® platform wall art with human in motion",
            "title": "IBM Quantum® platform wall art with human in motion",
            "src": "/workplace-xg/static/4872166068f10965a919fa0ba69f349d/2e753/quantum-computer-wall-art-with-human-in-motion.jpg",
            "srcSet": ["/workplace-xg/static/4872166068f10965a919fa0ba69f349d/69549/quantum-computer-wall-art-with-human-in-motion.jpg 288w", "/workplace-xg/static/4872166068f10965a919fa0ba69f349d/473e3/quantum-computer-wall-art-with-human-in-motion.jpg 576w", "/workplace-xg/static/4872166068f10965a919fa0ba69f349d/2e753/quantum-computer-wall-art-with-human-in-motion.jpg 1152w", "/workplace-xg/static/4872166068f10965a919fa0ba69f349d/a052a/quantum-computer-wall-art-with-human-in-motion.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "578px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB6lLYxukSAD//xAAbEAACAgMBAAAAAAAAAAAAAAAAAREhAhAxQf/aAAgBAQABBQJ0URIxY66eH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAAICAwEAAAAAAAAAAAAAAAABEBExMlFB/9oACAEBAAY/AuUcsweuNmIcf//EABwQAAIDAQADAAAAAAAAAAAAAAERACExQWGRwf/aAAgBAQABPyFOG8NjJhlmmdB7y4KKC7hmhfyBFlF5BkYQ2k0ahsz/2gAMAwEAAgADAAAAEDQowf/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABcRAAMBAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8Q2s//xAAeEAEAAwACAgMAAAAAAAAAAAABABEhMUFhcVGR8P/aAAgBAQABPxCkaYW0d9HzLp6lEQMzxfFe5S9MGsB+IKGzuiV1m14nbhoUEdD2cxLt+RCvsmV2hvGuI11a6qqqJZfU/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "brass detail of IBM Quantum® platform wall art",
            "title": "brass detail of IBM Quantum® platform wall art",
            "src": "/workplace-xg/static/ed7ed486e52f3cf0e6bebd1389cae96e/666d6/detail-view-of-quantum-wall-art.jpg",
            "srcSet": ["/workplace-xg/static/ed7ed486e52f3cf0e6bebd1389cae96e/69549/detail-view-of-quantum-wall-art.jpg 288w", "/workplace-xg/static/ed7ed486e52f3cf0e6bebd1389cae96e/473e3/detail-view-of-quantum-wall-art.jpg 576w", "/workplace-xg/static/ed7ed486e52f3cf0e6bebd1389cae96e/666d6/detail-view-of-quantum-wall-art.jpg 578w"],
            "sizes": "(max-width: 578px) 100vw, 578px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAF7bRE0plf/xAAaEAACAgMAAAAAAAAAAAAAAAAAAQIRAxAh/9oACAEBAAEFAuopjhkvf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAEQISD/2gAIAQEABj8Cqgx//8QAGBAAAgMAAAAAAAAAAAAAAAAAABEBICH/2gAIAQEAAT8hRnDzSKf/2gAMAwEAAgADAAAAEPjP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Qh//EABkQAQEBAQEBAAAAAAAAAAAAAAEAETFBof/aAAgBAQABPxAxBRX5PUoPJrL4ukwpa3//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Be Equal painted wood slat wall",
            "title": "Be Equal painted wood slat wall",
            "src": "/workplace-xg/static/24aa5d23d6fc0ee55ffee7d403f1a522/2e753/be-equal-painted-wood-slat-wall.jpg",
            "srcSet": ["/workplace-xg/static/24aa5d23d6fc0ee55ffee7d403f1a522/69549/be-equal-painted-wood-slat-wall.jpg 288w", "/workplace-xg/static/24aa5d23d6fc0ee55ffee7d403f1a522/473e3/be-equal-painted-wood-slat-wall.jpg 576w", "/workplace-xg/static/24aa5d23d6fc0ee55ffee7d403f1a522/2e753/be-equal-painted-wood-slat-wall.jpg 1152w", "/workplace-xg/static/24aa5d23d6fc0ee55ffee7d403f1a522/040c5/be-equal-painted-wood-slat-wall.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBQEE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAHWq75TWgHMIjWgv//EAB0QAAICAQUAAAAAAAAAAAAAAAECAxAAERIhMTP/2gAIAQEAAQUCPSNrUnEcHpjDcFQLX//EABURAQEAAAAAAAAAAAAAAAAAACBB/9oACAEDAQE/AYP/xAAXEQEAAwAAAAAAAAAAAAAAAAABEiAh/9oACAECAQE/AYrtP//EABgQAAMBAQAAAAAAAAAAAAAAAAABECER/9oACAEBAAY/Aqx7OMyf/8QAGhABAAIDAQAAAAAAAAAAAAAAAQARECFRMf/aAAgBAQABPyF005FdOHZOQVsNmBXwY9Y33H//2gAMAwEAAgADAAAAEGggAv/EABYRAQEBAAAAAAAAAAAAAAAAABEBIP/aAAgBAwEBPxCCx//EABcRAQEBAQAAAAAAAAAAAAAAABEBECH/2gAIAQIBAT8QcbyY0z//xAAbEAEBAAMBAQEAAAAAAAAAAAABEQAQITGB8P/aAAgBAQABPxBnkRJjePC+afhEeMzolH981a6MY4m8qU11/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Bee wall sign",
            "title": "Bee wall sign",
            "src": "/workplace-xg/static/4b34abd4054b91d6356ec5a3ee57ab51/473e3/bee-wall-sign.jpg",
            "srcSet": ["/workplace-xg/static/4b34abd4054b91d6356ec5a3ee57ab51/69549/bee-wall-sign.jpg 288w", "/workplace-xg/static/4b34abd4054b91d6356ec5a3ee57ab51/473e3/bee-wall-sign.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCAf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAGvsmEsZS0igP/EABsQAAICAwEAAAAAAAAAAAAAAAACARIDERMz/9oACAEBAAEFAqwVg1ElZsqtbB50U5qc0P/EABYRAAMAAAAAAAAAAAAAAAAAABEgIf/aAAgBAwEBPwGhP//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABoQAAIDAQEAAAAAAAAAAAAAAAAxAUKRIWH/2gAIAQEABj8CtpbS2jlEdmfDohCP/8QAGxAAAgMBAQEAAAAAAAAAAAAAAAERITFRQWH/2gAIAQEAAT8hUkRiRhVlKCUlKwjwfCEW56gSWlt74LnFxi5T/9oADAMBAAIAAwAAABCkJ33/xAAYEQEBAAMAAAAAAAAAAAAAAAARAQAQIf/aAAgBAwEBPxChHcLv/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAgEBPxBRlW//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUFRYXGR0f/aAAgBAQABPxBLFhwNfZaV6Yax58kG1ORh+ypNGojpbhvM2RmMYuZBJUHFeD1BGOjUpnBqAKPnP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "contemporary glass walled conference room",
            "title": "contemporary glass walled conference room",
            "src": "/workplace-xg/static/7d8fb2eb3d603dbbff83a38f5047e353/473e3/contemporary-glass-walled-conference-room.jpg",
            "srcSet": ["/workplace-xg/static/7d8fb2eb3d603dbbff83a38f5047e353/69549/contemporary-glass-walled-conference-room.jpg 288w", "/workplace-xg/static/7d8fb2eb3d603dbbff83a38f5047e353/473e3/contemporary-glass-walled-conference-room.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAACCElEQVQ4y2OY9+ED2Yhh8Gme8/YtBM1+82bu+/ckaJ7/8eOi798XffsGQQs+f8aqH4tmoDqgBhN/f+e0tPDWVhVz85nPn8//9AlTP7rmue/ezX71asnPn/bx8U4pKSF1dfpubkDHA8WBJIbm9x/gCCi94MuXZX/+zHr5suXkKWP/AC1Hp8pdu2c+fwE0DugckH4k9QzzPn6AoLkf3i/+8WPC7dt+5eV6bm79F873nj7ZfeLYtJvXrSLCHZNTOi9cACqAqwcihoXPPwLR/Kfvl3/4lbtwqYCEBAMDg2t82sv//z9++/vu658v//8nN3cBBbn4+GLau5a9+7Hg6XuILobd8//unv9n59zfh5b9tzLyZwCD7tI9Vzf+P7vy59mVvy5v+L+k6wYXOx9QXEFGZ9vsb3sX/N817w9QI8OBSf+BaN/EPydm/G9MWSPAJ+ZqGrNv0p83t///+vjv5/v/H5/8PTn/f6RLBQ+3QHZI/7Hp//dP/AvRxbB/6n84Ojrz/5ae9/um/Dg84/+mCc+Wtl1Y0nZxXe+9QzP+H5z2Z1PXuyMz/h6YhlDPsH/KfzjaO/nvoWlA8vfh6f/nVlw2VHHRkLXoytp9dMb/vZN+A6X2Tf6LrB5FM0T//in/9k0GuWLv5O87J3w9Nuv/PpDUv72oOrFoRpgyCagUZBCYgV0NTs3EoCGqGQDFJ4TvvTZ95AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Bee",
            "title": "Bee",
            "src": "/workplace-xg/static/9c104aaa731dcd6ea23cd66c5c6ea0c8/a5df1/environmental-elements-bee-flat.png",
            "srcSet": ["/workplace-xg/static/9c104aaa731dcd6ea23cd66c5c6ea0c8/7fc1e/environmental-elements-bee-flat.png 288w", "/workplace-xg/static/9c104aaa731dcd6ea23cd66c5c6ea0c8/a5df1/environmental-elements-bee-flat.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </ImageCollection>
    <Row className="resource-card-group mt-32" mdxType="Row">
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    
        <ResourceCard subTitle="IBM Workplace Design Brand Expression Guide" href="https://ibm.ent.box.com/s/i9vvhd4kg7hmj593oms8zsun9559j3yw" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX"
          }}></img>
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`Art elements`}</h2>
    <p>{`Art in IBM workplaces should be contemporary, forward-looking and thought-provoking, a reflection of IBM as a progressive leader in the modern world. It’s important that artwork represents the world in both subject matter and artist to mirror IBM as a global business. Artwork shouldn’t function purely as decor. It should be incorporated into the workplace in different applications:`}</p>
    <ul>
      <li parentName="ul">{`Site-specific installation, such as a mural`}</li>
      <li parentName="ul">{`Fine artwork that’s hung or framed`}</li>
      <li parentName="ul">{`Sculptural forms, as well as furniture elements`}</li>
    </ul>
    <p>{`Art should align with IBM’s values while integrating local content, geography and culture. It should be identified early in the design process for coordination and composition with surrounding finishes and components.`}</p>
    <ImageCollection mdxType="ImageCollection">
  <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABgBAAMBAQAAAAAAAAAAAAAAAAABAgME/9oADAMBAAIQAxAAAAFvSZQQwbjJStoipQgb8/8A/8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIAAxARBBIUMTL/2gAIAQEAAQUCyLBZVTLafxKpbcCyvyHsep//xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AbrP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPwG4j//EACAQAAAEBgMAAAAAAAAAAAAAAAABAhEQEiEyUZEgInH/2gAIAQEABj8CibIftgEk7sQo+hPWbwXFrh//xAAZEAEAAwEBAAAAAAAAAAAAAAABABEhMUH/2gAIAQEAAT8ho9qDfNjptTZFFadRhk9PohyF3rUKA2dWK4CLUVuf/9oADAMBAAIAAwAAABDvxDP/xAAYEQACAwAAAAAAAAAAAAAAAAAAIRARYf/aAAgBAwEBPxC3CND/xAAZEQADAAMAAAAAAAAAAAAAAAAAAREQUWH/2gAIAQIBAT8QaiuI9nA//8QAHhABAQEBAAICAwAAAAAAAAAAAREAMSFRYaFxgZH/2gAIAQEAAT8QH17yqd0Yor2GpyW8maRkNpxB96QQCgn5D7PjPEc/gZf3MKgEQafs3Mfy7jJ0eOoed//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Wall art at IBM Cambridge",
            "title": "Wall art at IBM Cambridge",
            "src": "/workplace-xg/static/45366e381e5c0ecfe1397a56ca57c797/473e3/wall-art-at-ibm-cambridge.jpg",
            "srcSet": ["/workplace-xg/static/45366e381e5c0ecfe1397a56ca57c797/69549/wall-art-at-ibm-cambridge.jpg 288w", "/workplace-xg/static/45366e381e5c0ecfe1397a56ca57c797/473e3/wall-art-at-ibm-cambridge.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={8} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAatli5xDR//EABgQAQEBAQEAAAAAAAAAAAAAAAECABIh/9oACAEBAAEFAjqwis0jHkdO5Tf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAYEAADAQEAAAAAAAAAAAAAAAAAARExQf/aAAgBAQAGPwLhqJEK6IiP/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBUf/aAAgBAQABPyHbzcMVibyJ7FQ1AUXpyfJ5s5hQ9Wf/2gAMAwEAAgADAAAAED8v/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EFB0/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAERQf/aAAgBAgEBPxDUU//EABsQAQEAAgMBAAAAAAAAAAAAAAERACExcYGh/9oACAEBAAE/EE5qVpWswzUjFXZ94mbpBKLi0VHNt04AUBgkJZue4riYAFdd5//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "colorful modern painting",
            "title": "colorful modern painting",
            "src": "/workplace-xg/static/2db6d4d0b1c3e83b3b7d14768852ad4e/2e753/colorful-modern-painting.jpg",
            "srcSet": ["/workplace-xg/static/2db6d4d0b1c3e83b3b7d14768852ad4e/69549/colorful-modern-painting.jpg 288w", "/workplace-xg/static/2db6d4d0b1c3e83b3b7d14768852ad4e/473e3/colorful-modern-painting.jpg 576w", "/workplace-xg/static/2db6d4d0b1c3e83b3b7d14768852ad4e/2e753/colorful-modern-painting.jpg 1152w", "/workplace-xg/static/2db6d4d0b1c3e83b3b7d14768852ad4e/a052a/colorful-modern-painting.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAdNgCgimf//EABoQAAIDAQEAAAAAAAAAAAAAAAERAAIhAzL/2gAIAQEAAQUCt02yJJ1AxuX9f//EABURAQEAAAAAAAAAAAAAAAAAABEQ/9oACAEDAQE/AVn/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAYEAACAwAAAAAAAAAAAAAAAAAAAiAhMf/aAAgBAQAGPwJqMj//xAAaEAEAAgMBAAAAAAAAAAAAAAABADEQESFx/9oACAEBAAE/IV7Upl9qgdIdueEWbQUik7cX/9oADAMBAAIAAwAAABCM3//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAwEBPxBwCy//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/EG9qKf/EABwQAQACAgMBAAAAAAAAAAAAAAEAETGhIUFhUf/aAAgBAQABPxARBfJtESW6OLI3uXt/HZuAMcFIsMo0eQ0w+E//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "long hallway art wall mural",
            "title": "long hallway art wall mural",
            "src": "/workplace-xg/static/2c3f33530e851099a4d528edb375dcd8/2e753/long-hallway-art-wall-mural.jpg",
            "srcSet": ["/workplace-xg/static/2c3f33530e851099a4d528edb375dcd8/69549/long-hallway-art-wall-mural.jpg 288w", "/workplace-xg/static/2c3f33530e851099a4d528edb375dcd8/473e3/long-hallway-art-wall-mural.jpg 576w", "/workplace-xg/static/2c3f33530e851099a4d528edb375dcd8/2e753/long-hallway-art-wall-mural.jpg 1152w", "/workplace-xg/static/2c3f33530e851099a4d528edb375dcd8/040c5/long-hallway-art-wall-mural.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </ImageCollection>
    <h2>{`Technology installations`}</h2>
    <p>{`When designing architectural technology installations, consider the long-term implications for ongoing content management. High-resolution media displays can add dynamism to the workplace. However, they require intensive content development. This maintenance should be considered as part of an ongoing expense to keep content fresh over long periods of time. Avoid looping advertising clips that are already out in the market. Use standard 16:9 aspect ratios for consistency with other digital platforms.`}</p>
    <p>{`Artistic technology installations can be programmed to work autonomously, pulling from existing data feeds. There are many other ways technology and software design can activate the environment. Consider API-driven data visualizations or responsive experiences. Built with custom software, the autonomous nature of these installations allieviates the constant content management requirements of media displays.`}</p>
    <p>{`Whenever possible, technology components should be integrated into the surrounding architecture. Consider finishes, accessibility and power or data requirements early on in the process. Consult with the IBM Brand Strategy and Experience Design team as well as the IBM Global Real Estate team to identify the best solution for your project.`}</p>
    <ImageCollection mdxType="ImageCollection">
  <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFAf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAF6amRMKQP/xAAYEAEBAQEBAAAAAAAAAAAAAAACAwEAEP/aAAgBAQABBQJU3OVXhlVI+//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAEDBQAAAAAAAAAAAAAAAAABAhESICEigf/aAAgBAQAGPwLViqTTwy2LP//EABoQAQEBAAMBAAAAAAAAAAAAAAERABAxUYH/2gAIAQEAAT8hMvxsl7R9ZMghknENDf/aAAwDAQACAAMAAAAQBy//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAWEQEBAQAAAAAAAAAAAAAAAAABAFH/2gAIAQIBAT8QEyb/xAAcEAEAAgMAAwAAAAAAAAAAAAABABEhMVFBYXH/2gAIAQEAAT8QaDxrKL95IYy0fKndEVdnI1R37KEyRY0Q5T//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "technology display in lobby",
            "title": "technology display in lobby",
            "src": "/workplace-xg/static/c003e2a49b8a68808911d93d4ed63e31/2e753/technology-display-in-lobby.jpg",
            "srcSet": ["/workplace-xg/static/c003e2a49b8a68808911d93d4ed63e31/69549/technology-display-in-lobby.jpg 288w", "/workplace-xg/static/c003e2a49b8a68808911d93d4ed63e31/473e3/technology-display-in-lobby.jpg 576w", "/workplace-xg/static/c003e2a49b8a68808911d93d4ed63e31/2e753/technology-display-in-lobby.jpg 1152w", "/workplace-xg/static/c003e2a49b8a68808911d93d4ed63e31/040c5/technology-display-in-lobby.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAEFAwIE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAahh2MmkerZuoJVI/8QAHRAAAgICAwEAAAAAAAAAAAAAAQIAAxIhBBEzE//aAAgBAQABBQLoTUxEpcvWr5Gy9/pxfJEwN3suhGUE/wD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEp/8QAHxAAAgEDBQEAAAAAAAAAAAAAAAEhAhHhEDEyYXGB/9oACAEBAAY/AsmTJO4+oGlZWPpVPJ3K/SNJR//EAB4QAQACAgEFAAAAAAAAAAAAAAEAERAhUTFBYXGR/9oACAEBAAE/ITyQnBlt7w8SUas6MrXO3uayyre8a0bfBgAUCoyyAs//2gAMAwEAAgADAAAAEPPtcv/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABcRAQEBAQAAAAAAAAAAAAAAAAEQETH/2gAIAQIBAT8Qx7BBk//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESExQVFhceH/2gAIAQEAAT8QEao+ifrE3hb1RQGhst4fIRYVpX4ruAUXVNmuZjwst9lT4FX61KOQM9w2ABgOI2ov7MS5/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "elevator lobby with wall art",
            "title": "elevator lobby with wall art",
            "src": "/workplace-xg/static/b7cc7370441a0164c8a05c438e473728/968f2/elevator-lobby-with-wall-art.jpg",
            "srcSet": ["/workplace-xg/static/b7cc7370441a0164c8a05c438e473728/69549/elevator-lobby-with-wall-art.jpg 288w", "/workplace-xg/static/b7cc7370441a0164c8a05c438e473728/473e3/elevator-lobby-with-wall-art.jpg 576w", "/workplace-xg/static/b7cc7370441a0164c8a05c438e473728/968f2/elevator-lobby-with-wall-art.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAQFAQID/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/2gAMAwEAAhADEAAAAeUyul1ncKtGsLJaGgjb/8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIAAwQREBITIjH/2gAIAQEAAQUC6y2xyaJ5tDnEDlGrsVrf/8QAFhEAAwAAAAAAAAAAAAAAAAAAAhAx/9oACAEDAQE/ARqGr//EABgRAAIDAAAAAAAAAAAAAAAAAAMQAiEy/9oACAECAQE/ASVFEyv/xAAfEAACAQIHAAAAAAAAAAAAAAABEQACEBITISIxQVH/2gAIAQEABj8ChXl9pw1JQ5nI0sF3KkZ//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFRof/aAAgBAQABPyHXkAgWekDeTtZ0AlwQtwQEJSa24HsF38n/2gAMAwEAAgADAAAAEIDgwf/EABoRAAEFAQAAAAAAAAAAAAAAAAABEBEhMVH/2gAIAQMBAT8QsITpg3//xAAaEQABBQEAAAAAAAAAAAAAAAAAARARITFR/9oACAECAQE/ELhK8N2//8QAHxABAQEAAgAHAAAAAAAAAAAAAREAIUExUWGR0eHx/9oACAEBAAE/EOcMn6fcySiD6uPr9sqVQ5DhaN88WloaWB+6nw0QEyF7PnLNxge0Lv/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Watson® wall art",
            "title": "IBM Watson® wall art",
            "src": "/workplace-xg/static/97d1ef8294de9389538b99b3ae253847/968f2/ibm-watson-wall-art.jpg",
            "srcSet": ["/workplace-xg/static/97d1ef8294de9389538b99b3ae253847/69549/ibm-watson-wall-art.jpg 288w", "/workplace-xg/static/97d1ef8294de9389538b99b3ae253847/473e3/ibm-watson-wall-art.jpg 576w", "/workplace-xg/static/97d1ef8294de9389538b99b3ae253847/968f2/ibm-watson-wall-art.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHUlEgKCf/EABoQAAMAAwEAAAAAAAAAAAAAAAABAgMRITH/2gAIAQEAAQUC8HkSJfJmmauW0z//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAeEAABAwQDAAAAAAAAAAAAAAAAAREhAhAxUTNxof/aAAgBAQAGPwJl0bJzbjTtyKfT/8QAGhABAAMBAQEAAAAAAAAAAAAAAQAhQTERYf/aAAgBAQABPyHOA9ZXdYBFDWEXB7eTkKewK0tfE//aAAwDAQACAAMAAAAQm/8A/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAwEBPxB1Gn//xAAWEQEBAQAAAAAAAAAAAAAAAAAAIQH/2gAIAQIBAT8Qyo//xAAbEAEBAAMAAwAAAAAAAAAAAAABEQAhMVGRsf/aAAgBAQABPxAUoFgLHWsQgUxtMS20X5gd1pUkaOYxdFSBnmTCMyKvb1n/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM lobby with curvilinear ceiling art",
            "title": "IBM lobby with curvilinear ceiling art",
            "src": "/workplace-xg/static/6872427a549e603c02f480c9fa6d69a6/2e753/ibm-lobby-with-curvilinear-ceiling-art.jpg",
            "srcSet": ["/workplace-xg/static/6872427a549e603c02f480c9fa6d69a6/69549/ibm-lobby-with-curvilinear-ceiling-art.jpg 288w", "/workplace-xg/static/6872427a549e603c02f480c9fa6d69a6/473e3/ibm-lobby-with-curvilinear-ceiling-art.jpg 576w", "/workplace-xg/static/6872427a549e603c02f480c9fa6d69a6/2e753/ibm-lobby-with-curvilinear-ceiling-art.jpg 1152w", "/workplace-xg/static/6872427a549e603c02f480c9fa6d69a6/040c5/ibm-lobby-with-curvilinear-ceiling-art.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      